import { useState } from 'react';
import { Button, Input, InputGroup } from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom';

export default function CustomerListFilterBar() {
  const [searchQuery, setSearchQuery] = useState('')
  const navigate = useNavigate();
  const handleFilter = () => {
    if (searchQuery) {
      let params = '?search=' + searchQuery;
      navigate({ pathname: '/musteriler/', search: params });
    } else {
      navigate({ pathname: '/musteriler/' });
    }
  }
  return (
    <InputGroup width={'auto'} gap={2}>
      <Input 
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown = {(e) => {if (e.key === 'Enter'){ handleFilter() }}}
        placeholder="Müşteri Soyadı ya da Telefon" 
        bg={'white'}
      />
      <Button onClick={handleFilter} colorScheme={'teal'}>Bul</Button>
    </InputGroup>
  )
}
